// Strips a trailing number off a Pup card's catalog `name` for DISPLAY only.
//
// The backend numbers the copies of a repeated card so the catalog reads unambiguously
// ("Psychic 1" / "Psychic 2" / "Psychic 3", "Cancel2", "Counter2"), but the number is
// bookkeeping — on the felt those cards should read as plain "Psychic" / "Cancel" /
// "Counter". Applied once where the catalog is ingested (pupCatalogSlice.buildByCode), so
// every renderer — the card face, the hand/staging/auto-play docks, the play overlay, the
// action log and the replay window — shows the same short name with no per-site call.
//
// Rules:
//   - only DIGIT characters at the very END go ("Psychic 2" and "Cancel2" both lose the 2);
//     any separator in front of them (space, hyphen, underscore) goes with them.
//   - digits anywhere else are untouched — this is a suffix rule, not a de-digiter.
//   - number WORDS are untouched, so "Plus One", "One Short", "One Man's Trash" and
//     "Seven Ate Nine" keep their names.
//   - a name that is nothing but digits is kept as-is rather than blanked, so a future
//     catalog entry can never render an empty header.
//
// This is purely presentational: the wire key is the card CODE, so nothing routes, matches
// or persists on the name. The backend catalog copy is unchanged.

const TRAILING_NUMBER = /[\s\-–—_.]*\d+\s*$/;

const pupDisplayName = (name) => {
  if (typeof name !== 'string') return name;
  const trimmed = name.trim();
  const stripped = trimmed.replace(TRAILING_NUMBER, '').trim();
  return stripped || trimmed;
};

export default pupDisplayName;
